module.exports = __webpack_public_path__ + "img/5.1b1f0651.png";